var exports = {
  "G": "infoIcon__gc0znp",
  "sY": "convertedText__5zI1sQ",
  "zr": "discussionLink__gnTMhc",
  "D6": "arrowIcon__zfgDCK",
};

module.exports = exports;
